import { CHART_COLORS } from "../styles/theme";

/* Palette des motifs d'absence (dans l'ordre renvoyé par l'API) */
const REASON_PALETTE = [
    CHART_COLORS.grey,
    CHART_COLORS.violet,
    CHART_COLORS.blue,
    CHART_COLORS.violetMid,
    CHART_COLORS.violetSoft,
    CHART_COLORS.blueSoft,
];

/**
 * Transforme la réponse de GET /hr/pilotage/absenteisme en modèle
 * consommé par AbsencesSection.
 */
export const mapAbsenteisme = (api) => {
    const joursAbsence = api.absence_days ?? 0;
    const motifs = (api.by_reason ?? []).map((r, i) => ({
        name: r.category_label,
        value: r.days ?? 0,
        pct:
            joursAbsence > 0
                ? Math.round(((r.days ?? 0) / joursAbsence) * 100)
                : 0,
        color: REASON_PALETTE[i % REASON_PALETTE.length],
    }));

    return {
        joursTravailles: api.worked_days ?? 0,
        joursAbsence,
        taux: api.absenteeism_rate ?? 0,
        dureeMoyenne: api.average_duration ?? 0,
        frequence: api.frequency ?? 0,
        motifs,
    };
};
